import { render } from "./LandingBand.vue?vue&type=template&id=58608a78"
import script from "./LandingBand.vue?vue&type=script&lang=js"
export * from "./LandingBand.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Github\\dev-mynet\\Products\\Hub\\web\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__